import { SidePopupLayout } from "src/component/SidePopupLayout"
import { AppSpan, AppText, Button, Circle, CustomContainer, FlexColumn, FlexRow, Form, FormGroupWithIcon, GridContainer, ScreenTitle } from "src/style"
import {ReactComponent as FlightIcon} from 'src/assets/img/flight-search-icon.svg'
import { FiChevronDown } from "react-icons/fi"

export const FlightDetails: React.FC<any> = ({handleNext, acctNo, handleAcctNo, data, close}) => {

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        handleNext()
    }

    return (
        <SidePopupLayout close={close}>
            <ScreenTitle textSize="2.2" fontWeight="700">Flight Details</ScreenTitle>
            <>
                <CustomContainer
                    minHeight="36.3" topMargin='2.5'
                    shadow="0px 4px 20px rgba(0, 0, 0, 0.15)"
                    topPadding="1.5" bottomPadding="1.5" bgColor="#ffffff"
                >
                    <AppText color="#52575C" fontFamily="Montserrat" leftPadding='2' rightPadding="2" >
                        Lagos <AppSpan color="#52575C" fontFamily="Montserrat" fontWeight="600">to Dubai</AppSpan>
                    </AppText>
                    <CustomContainer 
                        topMargin="1" padding="2" topPadding="1.5"
                        style={{borderTop: '1px solid #E8E8E8', borderBottom: '1px solid #E8E8E8'}}
                    >
                        <FlexRow>
                            <FlightIcon className="icon-component" />
                            <AppText textSize="1.2" leftMargin="1">Ethopian Airlines ET900</AppText>
                        </FlexRow>
                        <FlexRow alignItems="stretch" topMargin="1.5">
                            <CustomContainer width="50" sizeUnit="%">
                                <AppText textSize="1" fontWeight="600" fontFamily="Montserrat" bottomMargin="0.5">13:40</AppText>
                                <AppText textSize="1" color="#A0A4A8" fontFamily="Montserrat">4h 10m</AppText>
                                <AppText textSize="1" fontWeight="600" fontFamily="Montserrat" topMargin="0.5">21:00</AppText>
                            </CustomContainer>
                            <CustomContainer width="50" sizeUnit="%">
                                <FlexRow gap="1.5" alignItems="stretch">
                                    <GridContainer width="auto" sizeUnit="">
                                        <Circle size="1" borderColor="#52575C" />
                                        <CustomContainer width="0.1" height="2.3" bgColor="#A0A4A8" topMargin="0.4" bottomMargin="0.4" />
                                        <Circle size="1" borderColor="#52575C" />
                                    </GridContainer>
                                    <FlexColumn justifyContent="space-between" alignItems="flex-start">
                                        <AppText textSize="1" fontFamily="Montserrat">Lagos LOS</AppText>
                                        <AppText textSize="1" fontFamily="Montserrat" topMargin="1.5">Addis Ababa ADD</AppText>
                                    </FlexColumn>
                                </FlexRow>
                            </CustomContainer>
                        </FlexRow>
                    </CustomContainer>
                    <CustomContainer 
                        padding="2" topPadding="1.5"
                    >
                        <FlexRow>
                            <FlightIcon className="icon-component" />
                            <AppText textSize="1.2" leftMargin="1">Ethopian Airlines ET600</AppText>
                        </FlexRow>
                        <FlexRow alignItems="stretch" topMargin="1.5">
                            <CustomContainer width="50" sizeUnit="%">
                                <AppText textSize="1" fontWeight="600" fontFamily="Montserrat" bottomMargin="0.5">21:44</AppText>
                                <AppText textSize="1" color="#A0A4A8" fontFamily="Montserrat">4h 10m</AppText>
                                <AppText textSize="1" fontWeight="600" fontFamily="Montserrat" topMargin="0.5">02:55</AppText>
                            </CustomContainer>
                            <CustomContainer width="50" sizeUnit="%">
                                <FlexRow gap="1.5" alignItems="stretch">
                                    <GridContainer width="auto" sizeUnit="">
                                        <Circle size="1" borderColor="#52575C" />
                                        <CustomContainer width="0.1" height="2.3" bgColor="#A0A4A8" topMargin="0.4" bottomMargin="0.4" />
                                        <Circle size="1" borderColor="#52575C" />
                                    </GridContainer>
                                    <FlexColumn justifyContent="space-between" alignItems="flex-start">
                                        <AppText textSize="1" fontFamily="Montserrat">Addis Ababa ADD</AppText>
                                        <AppText textSize="1" fontFamily="Montserrat" topMargin="1.5">Dubai DXB</AppText>
                                    </FlexColumn>
                                </FlexRow>
                            </CustomContainer>
                        </FlexRow>
                    </CustomContainer>
                    <AppText fontWeight="500" fontFamily="Montserrat" leftPadding="2" rightPadding="2">
                        Amount:<AppSpan textSize="1.6" fontWeight="600" color="#27499D" fontFamily="Montserrat" leftMargin="1">₦45,000</AppSpan>
                    </AppText>
                </CustomContainer>
                <Form onSubmit={handleProceed} topMargin='2'>
                    <FormGroupWithIcon>
                        <label>Source Account</label>
                        <div className="input-with-icon">
                            <select 
                                name='accountNo'
                                value={acctNo}
                                style={{color: acctNo ? '#000000' : '#667085'}}
                                onChange={(e) => handleAcctNo(e.target.value)}
                                required
                            >
                                <option value="">Select Account</option>
                                <option value="2236728192">Qore - 2236728192</option>
                            </select>
                            <FiChevronDown className="input-with-icon-tag" />
                        </div>
                    </FormGroupWithIcon>
                    <FlexRow justifyContent="flex-end" topMargin='2'>
                        <Button 
                            width='11.2' height='4' 
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F' titleSize='1.4'
                        >
                            Pay to Book
                        </Button>
                    </FlexRow>
                </Form>
            </>
        </SidePopupLayout>
    )
}